
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.938 7H20a2 2 0 012 2v4a2 2 0 01-2 2h-1.062A8 8 0 0111 22v-2a6 6 0 006-6V8A6 6 0 105 8v7H2a2 2 0 01-2-2V9a2 2 0 012-2h1.062a8.001 8.001 0 0115.876 0zM2 9v4h1V9H2zm17 0v4h1V9h-1zM6.76 14.785l1.06-1.696a5.972 5.972 0 003.18.91 5.973 5.973 0 003.18-.91l1.06 1.696A7.963 7.963 0 0111 16a7.963 7.963 0 01-4.24-1.215z","fill":"#FAAD14"}})])
          )
        }
      }
    